import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useCookiePrefs } from "@/components/CookiePrefsContext";

export default function CookieBanner() {
  const { t } = useTranslation();
  const { bannerVisible, acceptAll, rejectAll, openManager } = useCookiePrefs();

  if (!bannerVisible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={t("cookie.banner_title")}
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-6 z-50 bg-card border border-border rounded-2xl p-4 sm:p-5 shadow-[0_18px_50px_rgba(18,20,23,0.14)]"
    >
      <div className="max-w-[1120px] mx-auto flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
        <div className="flex-1">
          <div className="eyebrow mb-1">{t("cookie.banner_title")}</div>
          <p className="text-sm text-foreground">
            {t("cookie.banner_body")}{" "}
            <Link
              to={`/${(document.documentElement.lang || "hr")}/cookies`}
              className="underline underline-offset-4 decoration-border hover:decoration-primary text-foreground"
              data-testid="cookie-banner-more-link"
            >
              {t("cookie.more")}
            </Link>
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 md:flex md:flex-nowrap gap-2 md:gap-2 md:justify-end">
          <Button
            type="button"
            variant="outline"
            onClick={rejectAll}
            data-testid="cookie-banner-reject-all"
            className="h-10 rounded-lg tracking-[0.04em]"
          >
            {t("cookie.reject_all")}
          </Button>
          <Button
            type="button"
            variant="ghost"
            onClick={openManager}
            data-testid="cookie-banner-manage-preferences"
            className="h-10 rounded-lg tracking-[0.04em]"
          >
            {t("cookie.manage")}
          </Button>
          <Button
            type="button"
            onClick={acceptAll}
            data-testid="cookie-banner-accept-all"
            className="h-10 rounded-lg tracking-[0.04em]"
          >
            {t("cookie.accept_all")}
          </Button>
        </div>
      </div>
    </div>
  );
}
